const TextInput = ({ title, identifier, inputType, ...attributes }) => {
  return (
    <>
      <label htmlFor={`lws-${identifier}`}>{title}</label>
      <input
        required
        className="text-input"
        type={inputType}
        id={`lws-${identifier}`}
        {...attributes}
      />
    </>
  );
};

export default TextInput;
